import React from 'react';
import s from './SophisticatedTooltipText.scss';
const SophisticatedTooltipText = ({ children })=>{
    return /*#__PURE__*/ React.createElement("span", {
        className: s['root']
    }, children);
};
SophisticatedTooltipText.displayName = 'SophisticatedTooltipText';
export default SophisticatedTooltipText;

//# sourceMappingURL=SophisticatedTooltipText.js.map